import { CustomError } from 'components/error/Error';

export default function MainXml() {
  return (
    <CustomError code={404}/>
  );
}

export const getServerSideProps = async (ctx) => {
  if (ctx.res) {
    if (!ctx?.req?.state?.customDomain) {
      return {
        props: {},
      };
    }
    const { StoreRepo } = require('server/repositories/shop');
    const CONFIG = require('server/config').default;
    const Axios = require('axios').default;
    const shop = await StoreRepo.getShopByCtx(ctx);
    const baseUrl = `https://becca-cdn${CONFIG.ENV === 'production' ? '' : `-staging`}.windo.live`;
    try {
      const { data } = await Axios.get(`${baseUrl}/sitemaps/v1/${shop._id}/products.xml`);
      ctx.res.setHeader('Content-Type', 'text/xml');
      ctx.res.write(data);
      ctx.res.end();
    } catch (e) {
      return {
        props: {},
      };
    }
  }
  return {
    props: {},
  };
};
